import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=dd971ff4&"
import script from "./Network.vue?vue&type=script&lang=ts&"
export * from "./Network.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports